export default __webpack_public_path__ + "static/media/phone-call.8ef68603.svg";